module.exports = __webpack_public_path__ + "img/embedded6.aa9990e1.png";